module.exports = __webpack_public_path__ + "img/karte.d244a0c4.png";